import React, { useEffect, useState } from "react";
import styles from "./styles";
import { Grid } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

import Axis from "../../../../images/axis.svg";
import Curves from "../../../../images/curves.svg";
import SwLine from "../../../../images/Price-ceilingLine.svg";
import horGreenHalf from "../../../../images/horGreenHalf.jpg";
import HorRedHalf from "../../../../images/horRedHalf.jpg";
import vertRed from "../../../../images/vertRed.svg";
import vertRedHalf from "../../../../images/vertRedHalf.svg";
// import QsWhite from "../../../../images/QsWhite.svg";
import Q1WhiteCSPS from "../../../../images/Q1White-CSPS.svg";
import Q2WhiteCSPS from "../../../../images/Q2White-CSPS.svg";

// import QdWhite from "../../../../images/QdWhite.svg";
import HorBlueHalf from "../../../../images/horBlueHalf.jpg";
import HorBlueHalf2 from "../../../../images/horBlueHalf2.jpg";
import HorWhite from "../../../../images/Powhite.svg";
import VertWhite from "../../../../images/Qo-Vert-white.svg";
import VertWhiteSimple from "../../../../images/vertWhiteSimple.svg";
import VertBlueSimple from "../../../../images/vertBlueSimple.svg";
import HalfBlue from "../../../../images/Qd2BlueHalf.svg";
import VertGreenHalf from "../../../../images/VertGreenHalf.svg";
import { mergeClasses } from "@material-ui/styles";

const Internationl2 = (props) => {
  const {
    classes,
    submitted,
    setAnsweredCorrectly,
    questionAnswer,
    setAnsweredPartialy,
    setAnswers,
    answers,
  } = props;

  const [onSelect, setOnSelect] = useState(-1);
  const [selected, setSelected] = useState([]);
  const [correctAnswer, setCorrectAnswer] = useState(questionAnswer.answer);

  const [horBlueHalf1, setHorBlueHalf1] = useState(false);
  const [horRedHalf1, setHorRedHalf1] = useState(false);
  const [horGreenHalf1, setHorGreenHalf1] = useState(false);

  const [horBlueHalf2, setHorBlueHalf2] = useState(false);
  const [horRedHalf2, setHorRedHalf2] = useState(false);
  const [horGreenHalf2, setHorGreenHalf2] = useState(false);

  const [verBlueHalf3, setVerBlueHalf3] = useState(false);
  const [verRedHalf3, setVerRedHalf3] = useState(false);
  const [verGreenHalf3, setVerGreenHalf3] = useState(false);

  const [verBlueHalf4, setVerBlueHalf4] = useState(false);
  const [verRedHalf4, setVerRedHalf4] = useState(false);
  const [verGreenHalf4, setVerGreenHalf4] = useState(false);

  const [verBlueHalf5, setVerBlueHalf5] = useState(false);
  const [verRedHalf5, setVerRedHalf5] = useState(false);

  const [verBlue6, setVerBlue6] = useState(false);
  const [verRed6, setVerRed6] = useState(false);

  const [verBlue7, setVerBlue7] = useState(false);
  const [verRed7, setVerRed7] = useState(false);

  const [verBlueHalf8, setVerBlueHalf8] = useState(false);
  const [verRedHalf8, setVerRedHalf8] = useState(false);

  const changeBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "#a3cfd9";
    }
  };

  const resetBackground = (e) => {
    if (!submitted) {
      e.target.style.background = "#fff";
    }
  };

  console.log("onSelect", onSelect);

  const markSelected = (triangle) => {
    if (!submitted) {
      setOnSelect(1);
      let temp = selected;
      if (selected.includes(triangle)) {
        const index = temp.indexOf(triangle);
        // if (index > -1) {
        temp.splice(index, 1);
        // }
        // temp.pop(triangle);
        setSelected(temp);
      } else {
        temp.push(triangle);
        setSelected(temp);
      }

      if (!submitted && selected.includes(4) && selected.includes(5)) {
        setVerBlueHalf3(true);
      } else {
        setVerBlueHalf3(false);
      }

      if (!submitted && selected.includes(4) && selected.includes(9)) {
        setHorBlueHalf1(true);
      } else {
        setHorBlueHalf1(false);
      }

      if (!submitted && selected.includes(5) && selected.includes(10)) {
        setHorBlueHalf2(true);
      } else {
        setHorBlueHalf2(false);
      }

      if (!submitted && selected.includes(7) && selected.includes(8)) {
        setVerBlue7(true);
      } else {
        setVerBlue7(false);
      }

      if (!submitted && selected.includes(9) && selected.includes(10)) {
        setVerBlueHalf4(true);
      } else {
        setVerBlueHalf4(false);
      }

      if (!submitted && selected.includes(11) && selected.includes(12)) {
        setVerBlueHalf5(true);
      } else {
        setVerBlueHalf5(false);
      }

      if (!submitted && selected.includes(12) && selected.includes(13)) {
        setVerBlue6(true);
      } else {
        setVerBlue6(false);
      }

      if (!submitted && selected.includes(13) && selected.includes(14)) {
        setVerBlueHalf8(true);
      } else {
        setVerBlueHalf8(false);
      }
    }
  };

  useEffect(() => {
    setOnSelect(2);
  }, [onSelect]);

  const notQuiteFun = () => {
    let is_partial = "F";
    selected.map((ans) => {
      if (is_partial || is_partial === "F") {
        is_partial = true;
      }
      if (!questionAnswer.answer.includes(ans)) {
        is_partial = false;
      }
    });
    return is_partial === true ? true : false;
  };

  useEffect(() => {
    let is_true = true;
    questionAnswer.answer.map((ans) => {
      if (!selected.includes(ans)) {
        is_true = false;
      }
    });
    const answer = is_true && selected.length === questionAnswer.answer.length;
    if (submitted) {
      let tempAnswer = answers;
      if (answer) {
        tempAnswer.push(true);
        setAnswers(tempAnswer);
        if (
          questionAnswer.answer.includes(4) &&
          questionAnswer.answer.includes(5)
        ) {
          setVerBlueHalf3(false);
          setVerGreenHalf3(true);
        }
        if (
          questionAnswer.answer.includes(4) &&
          questionAnswer.answer.includes(9)
        ) {
          setHorBlueHalf1(false);
          setHorGreenHalf1(true);
        }
        if (
          questionAnswer.answer.includes(5) &&
          questionAnswer.answer.includes(10)
        ) {
          setHorBlueHalf2(false);
          setHorGreenHalf2(true);
        }
        if (
          questionAnswer.answer.includes(9) &&
          questionAnswer.answer.includes(10)
        ) {
          setVerBlueHalf4(false);
          setVerGreenHalf4(true);
        }
        setAnsweredCorrectly(true);
      } else {
        tempAnswer.push(false);
        setAnswers(tempAnswer);
        let is_partial = false;
        if (selected.length < questionAnswer.answer.length) {
          is_partial = notQuiteFun();
          // selected.map((ans) => {
          //   is_partial = true;
          //   if (!questionAnswer.answer.includes(ans)) {
          //     is_partial = false;
          //   }
          // });
        }
        if (is_partial) {
          setAnsweredPartialy(true);
        } else {
          setAnsweredPartialy(false);
          setAnsweredCorrectly(false);
        }
        if (
          questionAnswer.answer.includes(4) &&
          questionAnswer.answer.includes(5)
        ) {
          setVerRedHalf3(false);
          setVerBlueHalf3(false);
          setVerGreenHalf3(true);
        }
        if (
          questionAnswer.answer.includes(4) &&
          questionAnswer.answer.includes(9)
        ) {
          setHorRedHalf1(false);
          setHorBlueHalf1(false);
          setHorGreenHalf1(true);
        }
        if (
          questionAnswer.answer.includes(5) &&
          questionAnswer.answer.includes(10)
        ) {
          setHorRedHalf2(false);
          setHorBlueHalf2(false);
          setHorGreenHalf2(true);
        }
        if (
          questionAnswer.answer.includes(9) &&
          questionAnswer.answer.includes(10)
        ) {
          setVerRedHalf4(false);
          setVerBlueHalf4(false);
          setVerGreenHalf4(true);
        }
        if (selected.includes(4) || selected.includes(5)) {
          if (
            questionAnswer.answer.includes(4) &&
            questionAnswer.answer.includes(5)
          ) {
            setVerBlueHalf3(false);
            setVerGreenHalf3(true);
          } else {

            if(selected.includes(4) && questionAnswer.answer.includes(4)){
              setVerBlueHalf3(false);
              setVerGreenHalf3(true);
            }
            else if(selected.includes(5) && questionAnswer.answer.includes(5)){
              setVerBlueHalf3(false);
              setVerGreenHalf3(true);
            }else{
              setVerBlueHalf3(false);
              setVerRedHalf3(true);
            }

          }
        }

        if (selected.includes(4) || selected.includes(9)) {
          if (
            questionAnswer.answer.includes(4) &&
            questionAnswer.answer.includes(9)
          ) {
            setHorBlueHalf1(false);
            setHorGreenHalf1(true);
          } else {

            if(selected.includes(4) && questionAnswer.answer.includes(4)){
              setHorBlueHalf1(false);
              setHorGreenHalf1(true);
            }
            else if(selected.includes(9) && questionAnswer.answer.includes(9)){
              setHorBlueHalf1(false);
              setHorGreenHalf1(true);
            }else{
              setHorBlueHalf1(false);
              setHorRedHalf1(true);
            }

          }
        }
        if (selected.includes(5) || selected.includes(10)) {
          if (
            questionAnswer.answer.includes(5) &&
            questionAnswer.answer.includes(10)
          ) {
            setHorBlueHalf2(false);
            setHorGreenHalf2(true);
          } else {

            if(selected.includes(5) && questionAnswer.answer.includes(5)){
              setHorBlueHalf2(false);
              setHorGreenHalf2(true);
            }
            else if(selected.includes(10) && questionAnswer.answer.includes(10)){
              setHorBlueHalf2(false);
              setHorGreenHalf2(true);
            }else{
              setHorBlueHalf2(false);
              setHorRedHalf2(true);
            }
          }
        }
        if (selected.includes(9) || selected.includes(10)) {
          if (
            questionAnswer.answer.includes(9) &&
            questionAnswer.answer.includes(10)
          ) {
            setVerBlueHalf4(false);
            setVerGreenHalf4(true);
          } else {
            if(selected.includes(9) && questionAnswer.answer.includes(9)){
              setVerBlueHalf4(false);
              setVerGreenHalf4(true);
            }
            else if(selected.includes(10) && questionAnswer.answer.includes(10)){
              setVerBlueHalf4(false);
              setVerGreenHalf4(true);
            }else{
              setVerBlueHalf4(false);
              setVerRedHalf4(true);
            }
          }
        }
        if (selected.includes(11) && selected.includes(12)) {
          setVerBlueHalf5(false);
          setVerRedHalf5(true);
        }
        if (selected.includes(12) && selected.includes(13)) {
          setVerBlue6(false);
          setVerRed6(true);
        }
        if (selected.includes(13) && selected.includes(14)) {
          setVerBlueHalf8(false);
          setVerRedHalf8(true);
        }
        if (selected.includes(7) && selected.includes(8)) {
          setVerBlue7(false);
          setVerRed7(true);
        }
      }
    }
  }, [submitted]);

  const checkSelection = (triangle) => selected.includes(triangle);

  const demandCurveResponsive = () => {
    return (
      <div className={classes.internationalContainerMajor}>
        <div className={classes.internationalContainerChild}>
          <img src={Axis} style={{ height: "100%", zIndex: 2 }} alt="" />
          <img
            src={Curves}
            style={{ height: "100%", position: "absolute", zIndex: 2 }}
            alt=""
          />
          <img
            src={SwLine}
            style={{
              height: "9.5%",
              position: "absolute",
              zIndex: 2,
              marginLeft: "6.5%",
              paddingTop: "24%",
            }}
            alt=""
          />

          <img className={classes.line1} src={HorWhite} alt="" />

          <img
            className={classes.line2}
            src={HorBlueHalf}
            style={{
              zIndex: horBlueHalf1 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line3}
            src={horGreenHalf}
            style={{
              zIndex: horGreenHalf1 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line4}
            src={HorRedHalf}
            style={{
              zIndex: horRedHalf1 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line5}
            src={HorBlueHalf2}
            style={{
              zIndex: horBlueHalf2 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line6}
            src={horGreenHalf}
            style={{
              zIndex: horGreenHalf2 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line7}
            src={HorRedHalf}
            style={{
              zIndex: horRedHalf2 ? 1 : -1,
            }}
            alt=""
          />

          <img className={classes.line8} src={VertWhite} alt="" />

          <img
            className={classes.line9}
            src={VertBlueSimple}
            style={{
              zIndex: verBlue6 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line10}
            src={vertRed}
            style={{
              zIndex: verRed6 ? 1 : -1,
            }}
            alt=""
          />

          <img className={classes.line11} src={VertWhiteSimple} alt="" />

          <img
            className={classes.line15}
            src={HalfBlue}
            style={{
              zIndex: verBlueHalf3 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line16}
            src={VertGreenHalf}
            style={{
              zIndex: verGreenHalf3 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line17}
            src={vertRedHalf}
            style={{
              zIndex: verRedHalf3 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line18}
            src={HalfBlue}
            style={{
              zIndex: verBlueHalf4 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line19}
            src={VertGreenHalf}
            style={{
              zIndex: verGreenHalf4 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line20}
            src={vertRedHalf}
            style={{
              zIndex: verRedHalf4 ? 1 : -1,
            }}
            alt=""
          />

          <img className={classes.line21} src={VertWhiteSimple} alt="" />

          <img
            className={classes.line22}
            src={VertBlueSimple}
            style={{
              zIndex: verBlue7 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line23}
            src={vertRed}
            style={{
              zIndex: verRed7 ? 1 : -1,
            }}
            alt=""
          />

          <img className={classes.line24} src={Q1WhiteCSPS} alt="" />

          <img
            className={classes.line25}
            src={vertRedHalf}
            style={{
              zIndex: verRedHalf5 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line26}
            src={HalfBlue}
            style={{
              zIndex: verBlueHalf8 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line27}
            src={vertRedHalf}
            style={{
              zIndex: verRedHalf8 ? 1 : -1,
            }}
            alt=""
          />

          <img
            className={classes.line28}
            src={HalfBlue}
            style={{
              zIndex: verBlueHalf5 ? 1 : -1,
            }}
            alt=""
          />

          <img className={classes.line29} src={Q2WhiteCSPS} alt="" />

          <div className={classes.shape1Major}>
            <div
              className={classes.shape1Child}
              style={{
                float: "left",
                clipPath: "polygon(28% 100%, 72% 100%, 100% 0, 0 0)",
                shapeOutside: "polygon(28% 100%, 72% 100%, 100% 0, 0 0)",
                width: "100%",
                marginTop: 4,
                backgroundColor: submitted
                  ? correctAnswer.includes(1)
                    ? "green"
                    : selected.includes(1)
                    ? "red"
                    : "#fff"
                  : selected.includes(1)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(1)
                  ? console.log("hhhh")
                  : !checkSelection(1) && resetBackground
              }
              onMouseOver={
                selected.includes(1)
                  ? console.log("1")
                  : !checkSelection(1) && changeBackground
              }
              onClick={() => markSelected(1)}
            />
          </div>

          <div className={classes.shape2Major}>
            <div
              className={classes.shape2Child}
              style={{
                float: "left",
                clipPath: "polygon(0 0, 0% 100%, 100% 100%)",
                shapeOutside: "polygon(0 0, 0% 100%, 100% 100%)",
                backgroundColor: submitted
                  ? correctAnswer.includes(2)
                    ? "green"
                    : selected.includes(2)
                    ? "red"
                    : "#fff"
                  : selected.includes(2)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(2)
                  ? console.log("hhhh")
                  : !checkSelection(2) && resetBackground
              }
              onMouseOver={
                selected.includes(2)
                  ? console.log("2")
                  : !checkSelection(2) && changeBackground
              }
              onClick={() => markSelected(2)}
            />
          </div>

          <div className={classes.shape3Major}>
            <div
              className={classes.shape3Child}
              style={{
                float: "left",
                clipPath: "polygon(100% 0, 0% 100%, 100% 100%)",
                shapeOutside: "polygon(100% 0, 0% 100%, 100% 100%)",
                width: "97%",
                marginTop: 5,
                backgroundColor: submitted
                  ? correctAnswer.includes(3)
                    ? "green"
                    : selected.includes(3)
                    ? "red"
                    : "#fff"
                  : selected.includes(3)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(3)
                  ? console.log("hhhh")
                  : !checkSelection(3) && resetBackground
              }
              onMouseOver={
                selected.includes(3)
                  ? console.log("3")
                  : !checkSelection(3) && changeBackground
              }
              onClick={() => markSelected(3)}
            />
          </div>

          <div className={classes.shape4Major}>
            <div
              className={classes.shape4Child}
              style={{
                float: "left",
                clipPath: "inset(0 0 0 0)",
                shapeOutside: "inset(0 0 0 0)",
                width: "100%",
                marginTop: 5,
                backgroundColor: submitted
                  ? correctAnswer.includes(4)
                    ? "green"
                    : selected.includes(4)
                    ? "red"
                    : "#fff"
                  : selected.includes(4)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(4)
                  ? console.log("hhhh")
                  : !checkSelection(4) && resetBackground
              }
              onMouseOver={
                selected.includes(4)
                  ? console.log("4")
                  : !checkSelection(4) && changeBackground
              }
              onClick={() => markSelected(4)}
            />
          </div>

          <div className={classes.shape5Major}>
            <div
              className={classes.shape5Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(5)
                    ? "green"
                    : selected.includes(5)
                    ? "red"
                    : "#fff"
                  : selected.includes(5)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(5)
                  ? console.log("hhhh")
                  : !checkSelection(5) && resetBackground
              }
              onMouseOver={
                selected.includes(5)
                  ? console.log("5")
                  : !checkSelection(5) && changeBackground
              }
              onClick={() => markSelected(5)}
            />
          </div>

          <div className={classes.shape6Major} style={{}}>
            <div
              className={classes.shape6Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(6)
                    ? "green"
                    : selected.includes(6)
                    ? "red"
                    : "#fff"
                  : selected.includes(6)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(6)
                  ? console.log("hhhh")
                  : !checkSelection(6) && resetBackground
              }
              onMouseOver={
                selected.includes(6)
                  ? console.log("6")
                  : !checkSelection(6) && changeBackground
              }
              onClick={() => markSelected(6)}
            />
          </div>

          <div className={classes.shape7Major}>
            <div
              className={classes.shape7Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(7)
                    ? "green"
                    : selected.includes(7)
                    ? "red"
                    : "#fff"
                  : selected.includes(7)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(7)
                  ? console.log("hhhh")
                  : !checkSelection(7) && resetBackground
              }
              onMouseOver={
                selected.includes(7)
                  ? console.log("7")
                  : !checkSelection(7) && changeBackground
              }
              onClick={() => markSelected(7)}
            />
          </div>

          <div className={classes.shape8Major}>
            <div
              className={classes.shape8Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(8)
                    ? "green"
                    : selected.includes(8)
                    ? "red"
                    : "#fff"
                  : selected.includes(8)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(8)
                  ? console.log("hhhh")
                  : !checkSelection(8) && resetBackground
              }
              onMouseOver={
                selected.includes(8)
                  ? console.log("8")
                  : !checkSelection(8) && changeBackground
              }
              onClick={() => markSelected(8)}
            />
          </div>

          <div className={classes.shape9Major}>
            <div
              className={classes.shape9Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(9)
                    ? "green"
                    : selected.includes(9)
                    ? "red"
                    : "#fff"
                  : selected.includes(9)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(9)
                  ? console.log("hhhh")
                  : !checkSelection(9) && resetBackground
              }
              onMouseOver={
                selected.includes(9)
                  ? console.log("9")
                  : !checkSelection(9) && changeBackground
              }
              onClick={() => markSelected(9)}
            />
          </div>

          <div className={classes.shape10Major}>
            <div
              className={classes.shape10Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(10)
                    ? "green"
                    : selected.includes(10)
                    ? "red"
                    : "#fff"
                  : selected.includes(10)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(10)
                  ? console.log("hhhh")
                  : !checkSelection(10) && resetBackground
              }
              onMouseOver={
                selected.includes(10)
                  ? console.log("10")
                  : !checkSelection(10) && changeBackground
              }
              onClick={() => markSelected(10)}
            />
          </div>

          <div className={classes.shape11Major}>
            <div
              className={classes.shape11Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(11)
                    ? "green"
                    : selected.includes(11)
                    ? "red"
                    : "#fff"
                  : selected.includes(11)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(11)
                  ? console.log("hhhh")
                  : !checkSelection(11) && resetBackground
              }
              onMouseOver={
                selected.includes(11)
                  ? console.log("11")
                  : !checkSelection(11) && changeBackground
              }
              onClick={() => markSelected(11)}
            />
          </div>

          <div className={classes.shape12Major}>
            <div
              className={classes.shape12Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(12)
                    ? "green"
                    : selected.includes(12)
                    ? "red"
                    : "#fff"
                  : selected.includes(12)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(12)
                  ? console.log("hhhh")
                  : !checkSelection(12) && resetBackground
              }
              onMouseOver={
                selected.includes(12)
                  ? console.log("12")
                  : !checkSelection(12) && changeBackground
              }
              onClick={() => markSelected(12)}
            />
          </div>

          <div className={classes.shape13Major}>
            <div
              className={classes.shape13Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(13)
                    ? "green"
                    : selected.includes(13)
                    ? "red"
                    : "#fff"
                  : selected.includes(13)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(13)
                  ? console.log("hhhh")
                  : !checkSelection(13) && resetBackground
              }
              onMouseOver={
                selected.includes(13)
                  ? console.log("13")
                  : !checkSelection(13) && changeBackground
              }
              onClick={() => markSelected(13)}
            />
          </div>

          <div className={classes.shape14Major}>
            <div
              className={classes.shape14Child}
              style={{
                backgroundColor: submitted
                  ? correctAnswer.includes(14)
                    ? "green"
                    : selected.includes(14)
                    ? "red"
                    : "#fff"
                  : selected.includes(14)
                  ? "#00b1d9"
                  : "#fff",
              }}
              onMouseOut={
                selected.includes(14)
                  ? console.log("hhhh")
                  : !checkSelection(14) && resetBackground
              }
              onMouseOver={
                selected.includes(14)
                  ? console.log("14")
                  : !checkSelection(14) && changeBackground
              }
              onClick={() => markSelected(14)}
            />
          </div>
        </div>
      </div>
    );
  };

  return <Grid style={{ width: 565 }}>{demandCurveResponsive()}</Grid>;
};

export default withStyles(styles)(Internationl2);
